<template>
  <div><Stores></Stores></div>
</template>

<script>
  import Stores from '@/expertoRetail/organisms/ExpertoRetailMobileDashboard'
  export default {
    name: 'mobile',
    props: [],
    components: {
      Stores
    },
    data () {
      return {
        textFilter: ''
      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/expertoRetail/views/Mobile.vue